var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M2 14.99v1.357c.35.213 3.146 1.65 8 1.65s7.65-1.435 8-1.649V14.99c0-1.716-3.807-3.05-4.078-3.152C13.07 13.366 11.812 14.5 10 14.5c-1.81 0-3.069-1.133-3.92-2.66-.269.1-4.08 1.43-4.08 3.15zM4.5 5.18C4.5 2.319 6.962 0 10 0s5.5 2.319 5.5 5.179c0 1.213-.212 3.075-.786 4.817C16.717 10.761 20 12.001 20 14.99v2.008C20 18.103 15.685 20 10 20S0 18.099 0 16.998V14.99c0-3 3.285-4.228 5.287-4.991-.575-1.743-.787-3.606-.787-4.82zM10 12.5c1.97 0 3.5-3.617 3.5-7.321C13.5 3.45 11.959 2 10 2S6.5 3.45 6.5 5.179C6.5 8.883 8.03 12.5 10 12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.75f7b550eca0ec44046d0e3dc165ba08.svg";
export { ForwardRef as ReactComponent };